module.exports = __webpack_public_path__ + "static/img/报警.6f37373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/越野车/报警.png
// module id = U/oH
// module chunks = 76